import React,{Component} from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import SliderRange from './SliderRange'

import {TextField,Select as CustomSelect} from './FormElements';

import GKEvent from '../events';
import axios from 'axios';
import { ajaxUri } from '../consts/index';
import Icon from './Icons';

import {validURL,l} from '../functions';

export default class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentDrop: '',
            currentTab: 2,
            expanded : '',
            error : {},
            // -------
            EZCONF_ENABLE_FLOAT_CHECKOUT : '',
            EZSCONF_FB_APP_ID : '',
            EZSCONF_FB_PAGE_ID : '',
            PS_COUNTRY_DEFAULT : '',

            EZCONF_NEW_ORDER_ID : '',

            EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL : '',
        }

        this._savefbCheckbox = this._savefbCheckbox.bind(this);
    }

    componentWillReceiveProps({currentTab}){
        if( this.props.currentTab !== currentTab )
            this.setState({ currentTab: currentTab });
    }

    dropDown = (current) => {
        if( this.state.currentDrop === current )
            this.setState({ currentDrop: null });
        else
            this.setState({ currentDrop: current });
    }

    _changePanel = panel => {
        this.setState({expanded:(this.state.expanded !== panel)?panel:null});
    };

    _savefbCheckbox = () => {
        this._setSetting('EZSCONF_FB_APP_ID',this.state.EZSCONF_FB_APP_ID);
        this._setSetting('EZSCONF_FB_PAGE_ID',this.state.EZSCONF_FB_PAGE_ID);
        GKEvent.notification('success',l('Facebook App Credentials successfully saved.'));
    }

    _setSetting = (key,value,messages = [],cb=() => {}) => {
        axios({
            method: 'post',
            url: ajaxUri,
            data: {
                request : 'setSetting',
                key : key,
                value : value
            }
        })
        .then(result => {
            this.setState({
                [key] : value
            },() => {
                if( messages.length > 0 ) {
                    let message = '';
        
                    if ( result.data.status === 'success' )
                        message = messages[0];
                    else
                        message = messages[1];
                    
                    GKEvent.notification(result.data.status,message);
                }
                cb();
            })
        })
        .catch(error => {
            GKEvent.notification('error',l('Error.'));
        });        
    }

    _getSetting = (key) => {
        axios({
            method: 'post',
            url: ajaxUri,
            data: {
                request : 'getSetting',
                key : key
            }
        })
        .then(result => {
            this.setState({
                [key] : result.data
            })
        })
        .catch(error => {
            GKEvent.notification('error',l('Error.'));
        });        
    }

    _setStartingOrderId = () => {
        axios({
            method: 'post',
            url: ajaxUri,
            data: {
                request : 'startingOrderId',
                order_id : this.state.EZCONF_NEW_ORDER_ID
            }
        })
        .then(result => {
            GKEvent.notification(result.data.status,result.data.message);
        })
        .catch(error => {
            GKEvent.notification('error',l('Error.'));
        });        
    }

    _validURL = (str) => {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        
        if( str === "" )
            return true;

        return !!pattern.test(str);
    }

    _changeTabs = (tabId) => {
        const settings = {
            2 : ['EZSCONF_FB_APP_ID','EZSCONF_FB_PAGE_ID'],
            3 : ['EZCONF_ENABLE_FLOAT_CHECKOUT','PS_COUNTRY_DEFAULT','EZCONF_NEW_ORDER_ID','EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL']
        }

        this.setState({
            currentTab:tabId,
            currentDrop:null
        },() => {
            settings[tabId].forEach(key => {
                this._getSetting(key);
            })
        })
    }
    
    render () {
        return (
            <div className="palette-tab">
                <ul className="tab-head">
                    <li className={this.state.currentTab === 2?'active':''} onClick={() => {this._changeTabs(2)}}>{l('Checkout')}</li>
                </ul>
                <ul className="tab-body">
                    {
                        this.state.currentTab === 1 && <li style={{padding: 10}}>
                            <ExpansionPanel expanded={this.state.expanded === 'panel1'} onChange={() => {this._changePanel('panel1')}}>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <Typography>{l('"Add to cart" click action')}</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <FormControl>
                                        <Select
                                            value={this.state.EZCONF_ENABLE_FLOAT_CHECKOUT}
                                            onChange={(event) => {this._setSetting('EZCONF_ENABLE_FLOAT_CHECKOUT',event.target.value,[l('Add to cart action is updated successfully'),l('Error while updating add to cart action')])}}
                                        >
                                            <MenuItem value={0}>{l('Redirect to summary page')}</MenuItem>
                                            <MenuItem value={1}>{l('Flyout Cart')}</MenuItem>
                                            <MenuItem value={2}>{l('Popup Cart')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </li>
                    }
                    {
                        this.state.currentTab === 2 && <li>
                            <ul className="settings-area">
                                <li className={this.state.currentDrop === 37 ?'active':''}>
                                    <div className="head" onClick={() => this.dropDown(37)}><Icon icon={(this.state.currentDrop === 37)?'dropup':'dropdown'} />{l('"Add to cart" click action')}</div>
                                    {
                                        this.state.currentDrop === 37 && 
                                        <div className="body">
                                            <div className="section">
                                                <CustomSelect
                                                    dark
                                                    value={this.state.EZCONF_ENABLE_FLOAT_CHECKOUT.toString()}
                                                    onChange={(value) => {
                                                        this._setSetting('EZCONF_ENABLE_FLOAT_CHECKOUT',value,[l('Add to cart action is updated successfully'),l('Error while updating add to cart action')])
                                                    }}
                                                    placeholder={l('Please select')}
                                                    options={
                                                        [
                                                            {label :l('Redirect to checkout page'),value:'0'},
                                                            {label :l('Flyout Cart'),value:'1'},
                                                            {label :l('Popup Cart'),value:'2'},
                                                        ]
                                                    }
                                                />
                                            </div>
                                        </div>
                                    }
                                </li>
                                <li className={this.state.currentDrop === 35 ?'active':''}>
                                    <div className="head" onClick={() => this.dropDown(35)}><Icon icon={(this.state.currentDrop === 35)?'dropup':'dropdown'} />{l('Starting Order Number')}</div>
                                    {
                                        this.state.currentDrop === 35 && 
                                        <div className="body">
                                            <div className="section">
                                                <SliderRange
                                                    value={ this.state.EZCONF_NEW_ORDER_ID || 1 }
                                                    min={1}
                                                    max={9999}
                                                    onChange={(value) => { this.setState({EZCONF_NEW_ORDER_ID:value}) }}
                                                />
                                            </div>
                                            <div className="section text-center">
                                                <button className="gk-button gk-small gk-primary gk-default" onClick={this._setStartingOrderId}><span>{l('Save')}</span></button> 
                                            </div>
                                        </div>
                                    }
                                </li>
                                <li className={this.state.currentDrop === 36 ?'active':''}>
                                    <div className="head" onClick={() => this.dropDown(36)}><Icon icon={(this.state.currentDrop === 36)?'dropup':'dropdown'} />{l('Custom thank you page URL')}</div>
                                    {
                                        this.state.currentDrop === 36 && 
                                        <div className="body">
                                            <div className="section">
                                                <div className="gk-error-message"><p>{l('After Buyer lands on default thank you page he will be redirected to a custom thank you page in 5 seconds. Leave it blank if you do not want to redirect Buyer anywhere from default thank you page.')}</p></div>
                                                <TextField
                                                    placeholder={l('Thank you page URL')}
                                                    value={this.state.EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL}
                                                    onChange={(value) => { this.setState({EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL: value}) }}
                                                    dark
                                                    error={(!validURL(this.state.EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL || ""))?l('Url format not correct'):false}
                                                />
                                            </div>
                                            <div className="section text-center">
                                                <button 
                                                    className="gk-button gk-small gk-primary gk-default" 
                                                    disabled={!validURL(this.state.EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL || "")} 
                                                    onClick={() => {
                                                        this._setSetting('EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL',this.state.EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL,[l('Thank you page url updated successfully'),l('Error while updating the thank you page url')])
                                                    }}
                                                ><span>{l('Save')}</span></button> 
                                            </div>
                                        </div>
                                    }
                                </li>
                            </ul>
                        </li>
                    }
                </ul>
            </div>
        )
    };
}